module.exports = __webpack_public_path__ + "static/media/img_coaching-2.854d01ac.png";